import { DC_Domain_Models_Products_DiscontinueDisallowReason } from '@monorepo-types/dc';

/**
 * The four cancellation dialogs, still in the Sitecore field-wrapper shape.
 *
 * Declared here rather than imported from `@sitecore/types` so this library
 * carries no Sitecore dependency, but deliberately NOT flattened: both callers
 * live in flows that have not migrated yet (toonCancelationFlow,
 * ketelComfortCancelationFlow) and hand this their own wrapped content. It
 * flattens when the second of those two moves over.
 */
interface DialogValue {
  title?: string;
  content?: string;
  triggerText?: string;
  submitButtonText?: string | null;
  cancelButtonText?: string | null;
}

interface DialogField {
  value?: DialogValue;
  editable?: string;
}

export interface Dialogs {
  cancelledAlreadyDialog?: DialogField;
  minimumContractPeriodNotMetDialog?: DialogField;
  multipleServiceContractsActiveDialog?: DialogField;
  noActiveProductDialog?: DialogField;
}


export const getDialogContent = (
  dialogText: Dialogs | undefined,
  discontinueDialog: DC_Domain_Models_Products_DiscontinueDisallowReason | '',
  remainingMonths: number,
) => {
  const replaceContractPeriod = (text: string | undefined) => {
    return text ? text.replace('{contractPeriodRemaining}', remainingMonths.toString()) : '';
  };
  switch (discontinueDialog) {
    case 'cancelledAlready':
      return {
        title: dialogText?.cancelledAlreadyDialog?.value?.title ?? '',
        content: dialogText?.cancelledAlreadyDialog?.value?.content ?? '',
        triggerText: dialogText?.cancelledAlreadyDialog?.value?.triggerText ?? '',
      };
    case 'minimumContractPeriod':
      return {
        title: replaceContractPeriod(dialogText?.minimumContractPeriodNotMetDialog?.value?.title),
        content: dialogText?.minimumContractPeriodNotMetDialog?.value?.content ?? '',
        triggerText: dialogText?.minimumContractPeriodNotMetDialog?.value?.triggerText ?? '',
      };
    case 'moreThanOneMatchedProduct':
      return {
        title: dialogText?.multipleServiceContractsActiveDialog?.value?.title ?? '',
        content: dialogText?.multipleServiceContractsActiveDialog?.value?.content ?? '',
        triggerText: dialogText?.multipleServiceContractsActiveDialog?.value?.triggerText ?? '',
      };
    case 'noActiveProduct':
      return {
        title: dialogText?.noActiveProductDialog?.value?.title ?? '',
        content: dialogText?.noActiveProductDialog?.value?.content ?? '',
        triggerText: dialogText?.noActiveProductDialog?.value?.triggerText ?? '',
      };
  }
};
